@if (updatedAt) {
  <div
    nz-tooltip
    [nzTooltipTitle]="
      isClickable() ? ('general.open_change_history' | translate) : ''
    "
    [nzTooltipColor]="'#fff'"
    class="text-sm-legacy d-flex align-items-center"
    [class.clickable]="isClickable()"
    (click)="isClickable() && clickEvent.emit()"
  >
    <fa-icon
      [icon]="faCheckCircle"
      class="gray-legacy me-1"
      [class.green]="isChanged"
    ></fa-icon>
    <span>
      {{
        updatedAt
          | lastUpdate
            : {
                prefixText: 'general.last_saved' | translate,
                showSeconds: false,
              }
      }}
    </span>
    @if (isClickable()) {
      <span> &nbsp;- {{ 'general.change_history' | translate }} </span>
    }
  </div>
}
